<script setup>
import HorizontalJobTypesMenu from '@/components/Menus/JobTypes/HorizontalJobTypesMenu.vue'

definePage({ meta: { ...PageMeta.JobTypes.preview.meta, pageTitle: 'Job Type' } })

import JobTypePreviewPage from '@/views/setup/job-types/preview/JobTypePreviewPage.vue'

const route = useRoute()

/* ** */
</script>

<template>
  <section>
    <!-- Horizontal Menu / Navigation -->
    <VRow>
      <VCol cols="12">
        <HorizontalJobTypesMenu :job-type-g-u-i-d="route.params.guid" />
      </VCol>
    </VRow>

    <!-- Page -->
    <VRow>
      <VCol cols="12">
        <JobTypePreviewPage
          v-if="route.params.guid"
          :job-type-g-u-i-d="route.params.guid"
        />
      </VCol>
    </VRow>
  </section>
</template>
